import InnerComponent from '@Components/Logistics/GateDocument/ViewGateDocument';
import orgContainer from '@Components/AppContainer';

const ViewGateDocument = () => ((orgContainer(InnerComponent)));
export default ViewGateDocument;
